module.exports = __webpack_public_path__ + "img/icon-slot-black.1d15524d.svg";